import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Link } from "@tanstack/react-router";
import {
  Bell,
  Briefcase,
  Calendar,
  Download,
  FileText,
  Landmark,
  Users,
} from "lucide-react";

const websiteSections = [
  {
    title: "News & Notices",
    description: "Manage news articles and public notices for the website",
    icon: Bell,
    href: "/website/news-notices",
  },
  {
    title: "Events",
    description: "Add, edit, and delete events",
    icon: Calendar,
    href: "/website/events",
  },
  {
    title: "Financial Disclosures",
    description: "Campaign Financial Disclosures & Conflict of Interest forms",
    icon: FileText,
    href: "/website/disclosures",
  },
  {
    title: "Job Listings",
    description: "Add, edit, and delete job listings",
    icon: Briefcase,
    href: "/website/jobs",
  },
  {
    title: "Ordinances/Proclamations",
    description: "Manage official documents, ordinances, and proclamations",
    icon: FileText,
    href: "/website/documents",
  },
  {
    title: "Government Documents",
    description: "RFQs, Audits, Budgets, Codes, and Resolutions",
    icon: Landmark,
    href: "/website/government-documents",
  },
  {
    title: "Staff Directory",
    description: "Manage staff members and contact information",
    icon: Users,
    href: "/website/staff-directory",
  },
  {
    title: "Downloadable Resources",
    description: "City forms, maps, and downloadable documents",
    icon: Download,
    href: "/website/downloads",
  },
];

export function Website() {
  return (
    <div className="flex-1 space-y-4 p-8 pt-6">
      <div className="flex items-center justify-between space-y-2">
        <h2 className="text-3xl font-bold tracking-tight">
          Website Management
        </h2>
      </div>
      <p className="text-muted-foreground">Manage content for the website</p>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4 pt-4">
        {websiteSections.map((section) => (
          <Link key={section.href} to={section.href} className="group">
            <Card className="transition-all hover:shadow-lg hover:border-primary">
              <CardHeader>
                <div className="flex items-center gap-2">
                  <div className="p-2 rounded-lg bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-all">
                    <section.icon className="h-5 w-5" />
                  </div>
                </div>
                <CardTitle className="mt-4">{section.title}</CardTitle>
                <CardDescription>{section.description}</CardDescription>
              </CardHeader>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
